// frontend/src/main.jsx
// Build: 2025-12-24 02:08 - Deploy HMG (cache bust)
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./contexts/AuthContext";

// Build timestamp for cache busting
window.__BUILD_TIME__ = "2025-12-24T02:08:00";

// Import Global Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/css/styles.css";
import "./assets/css/painel.css";

// Interceptador HTTP
import "./utils/httpInterceptor";

import App from "./App.jsx";
import { registerSW } from "virtual:pwa-register";

const app = (
  <AuthProvider>
    <App />
  </AuthProvider>
);

createRoot(document.getElementById("root")).render(
  // Em DEV, NÃO usar StrictMode para evitar efeitos duplicados (React 18).
  // Em PROD, podemos manter StrictMode sem o problema.
  import.meta.env.PROD ? <StrictMode>{app}</StrictMode> : app
);

// Registra o Service Worker da PWA (somente em produ??o)
if (import.meta.env.PROD) {
  registerSW({ immediate: true });
}
